
export const ja = {
  site_title: '東京タワービューの高級賃貸マンション',
  
  // Navigation
  nav_home: 'ホーム',
  nav_rooms: '東京タワービューの部屋',
  nav_rental_guide: '賃貸ガイド',
  nav_life_support: '生活サポート',
  nav_contact: 'お問い合わせ',
  
  // Hero section
  hero_title: '東京の中心で、あなただけの特別な空間を',
  hero_subtitle: '厳選された高級アパートメントで、東京での滞在を最高の体験に',
  hero_cta: 'お部屋を見る',
  
  // Features
  features_title: '選ばれる理由',
  feature_1_title: 'プレミアムロケーション',
  feature_1_desc: '東京の主要エリアに位置する厳選された物件',
  feature_2_title: '完全家具付き',
  feature_2_desc: 'すぐに生活を始められる充実した設備',
  feature_3_title: '24時間サポート',
  feature_3_desc: '日本語・英語・中国語でのメールサポート',
  
  // Rooms
  rooms_title: '厳選されたお部屋',
  rooms_subtitle: 'あなたのライフスタイルに合わせた特別な空間をご提案',
  view_details: '詳細を見る',
  monthly_rent: '月額賃料',
  ask_price: 'ASK',
  reference_price: '参考価格',
  
  // Contact page
  contact_title: 'お問い合わせ',
  contact_subtitle: 'メールでお気軽にお問い合わせください',
  contact_info_title: 'お問い合わせ先',
  contact_email_label: 'メールアドレス',
  contact_email_response: '24時間以内にメールでご返信いたします',
  contact_method_label: 'お問い合わせ方法',
  contact_method_email_only: 'メールのみでの対応となります',
  contact_method_note: 'お電話でのお問い合わせは承っておりません',
  
  // Contact form
  contact_form_name: 'お名前',
  contact_form_name_placeholder: '山田太郎',
  contact_form_email: 'メールアドレス',
  contact_form_phone: '電話番号',
  contact_form_phone_placeholder: '090-1234-5678',
  contact_form_room_interest: 'ご興味のあるお部屋',
  contact_form_room_select: '選択してください',
  contact_form_room_other: 'その他・相談',
  contact_form_move_date: 'ご入居希望日',
  contact_form_message: 'お問い合わせ内容',
  contact_form_message_placeholder: 'ご質問やご要望をお聞かせください（500文字以内）',
  contact_form_characters: '文字',
  contact_form_success: 'お問い合わせを受け付けました。24時間以内にメールでご返信いたします。',
  contact_form_error: '送信に失敗しました。しばらく時間をおいて再度お試しください。',
  contact_form_sending: '送信中...',
  contact_form_submit: 'メールで問い合わせる',
  
  // Room titles
  room_shibuya_title: '渋谷プレミアムスタジオ',
  room_shinjuku_title: '新宿ラグジュアリー1LDK',
  room_roppongi_title: '六本木エグゼクティブスイート',
  
  // Rental guide
  rental_guide_title: '日本の賃貸ガイド',
  rental_guide_subtitle: '外国人の方も安心してお住まいいただくための完全ガイド',
  
  // Footer
  footer_contact_title: 'お問い合わせ',
  footer_support_hours: 'メールサポート対応',
  footer_copyright: '© 2024 Tokyo Rent. All rights reserved.',
  footer_link: 'Website Builder'
};